<template>
  <v-card elevation="0">
    <v-card-text class="py-16 px-6 px-md-10 text-center">
      <div class="pa-10 border rounded-lg">
        <div class="d-block mx-auto mt-5 mb-5">
          <img alt="Modern life illustration" :src="`${lender.image}`" width="200"/>
        </div>
        <div class="mt-16 px-8 text-center">
          <h3 class="blue--text text--darken-4" style="font-size: 1.1rem; line-height: 1.5rem">
            {{ lender.name }} will like to fund you
          </h3>
          <p class="black--text mt-4 mb-0">
            Congratulations, {{ $store.state.merchant.name }} has partnered with {{ lender.name }} to fund your request.
            Kindly provide required information to proceed
          </p>
        </div>
        <v-btn class="mt-12" color="primary" outlined @click="$emit('start')">Checkout</v-btn>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'BankWalkthrough',
  props: {
    lender: {
      type: Object,
      required: true
    }
  }
}
</script>
